import { render, staticRenderFns } from "./AdvertiserManagement.vue?vue&type=template&id=5e1d2058&"
import script from "./AdvertiserManagement.vue?vue&type=script&lang=js&"
export * from "./AdvertiserManagement.vue?vue&type=script&lang=js&"
import style0 from "./AdvertiserManagement.vue?vue&type=style&index=0&id=5e1d2058&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports